import { Box, Text, Flex, AccordionButton, AccordionIcon } from "@chakra-ui/react";

import { ReactNode } from "react";
import colors from "utils/colors";

const AccordionTitle = ({
  title,
  description,
  addon,
  isFirst = false,
}: {
  title: string;
  description: string;
  addon?: ReactNode | null;
  isFirst?: boolean;
}) => {
  return (
    <h2>
      <AccordionButton
        padding="1rem"
        _first={{
          borderTopRightRadius: isFirst ? "12px" : "0",
        }}
        _hover={{
          backgroundColor: colors.GRAY_50,
        }}
      >
        <Flex flexGrow="1" direction="column" textAlign="left" mr="18px">
          <Flex mb="8px" alignItems="center">
            <Box
              as="span"
              display="block"
              flex="1"
              textAlign="left"
              color="black"
              fontSize="16px"
              fontWeight="500"
            >
              {title}
            </Box>
            {addon}
          </Flex>
          <Text display="block" fontSize="13px">
            {description}
          </Text>
        </Flex>
        <AccordionIcon />
      </AccordionButton>
    </h2>
  );
};

export default AccordionTitle;
